import { AddressDropOffModalUpdater, AddressPickUpModalUpdater, DateTimeUpdater } from '.';
import { Avatar, Badge, Box, Button, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, SimpleGrid, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tooltip, Tr } from '@chakra-ui/react';
import { DeleteDialog, EmptyTable, Pagination } from '../../../components';
import { FiChevronDown, FiUser } from 'react-icons/fi';
import React, { useEffect, useMemo, useState } from 'react';
import { assignDeliveryDriver, assignDeliveryTruck, deleteDelivery, updateDeliveryPaymentMethod, updateDeliveryPaymentStatus, updateDeliveryStatus } from '../../../store/actions';
import { companyCustomerType, companyUserType, deliveryType, vehicelType, vehicleDriverType } from '../../../types';
import { useAppDispatch, useAppSelector } from '../../../hooks';

import { AppDispatch } from '../../../store';
import { BsTruck } from 'react-icons/bs';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

type TableProps = {
    deliveries: Array<deliveryType>;
    drivers: Array<vehicleDriverType>;
    vehicles: Array<vehicelType>;
    statuses: Array<string>;
    users: Array<companyUserType>;
    isOpen: boolean;
    setDeleteDialog: any;
    customers: Array<companyCustomerType>;
};

export const TableView = (props: TableProps) => {

    const [currentPage, setCurrentPage] = useState<number>(1);

    const { deliveries, drivers, vehicles, statuses, isOpen, customers, setDeleteDialog, users } = props;

    const { is_adding_delivery, is_updating_delivery } = useAppSelector(state => state.deliveryReducer);

    const PageSize = 10;

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const currentTableData: any = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        return deliveries.slice(firstPageIndex, lastPageIndex);
    }, [currentPage]);

    const getAddressPlace = (address: string) => {
        const place = address.split(',')[0];
        return place;
    };

    const getCustomerFullname = (delivery: deliveryType) => {
        const [customer] = customers && customers?.filter((customer: companyCustomerType) => customer?.customer_id === delivery?.customer_id);
        const fullname = `${customer?.first_name} ${customer?.last_name}`;
        return fullname;
    };

    const getVehicleMake = (delivery: deliveryType) => {
        const [vehicle] = vehicles && vehicles?.filter((vehicle: vehicelType) => vehicle?.vehicle_id === delivery?.truck_id);
        const truck = `${vehicle?.make} - ${vehicle?.model}`;
        return truck;
    };

    const getDriverName = (delivery: deliveryType) => {
        const [driver] = users && users?.filter((user: companyUserType) => user?.user_id === delivery?.driver_id);
        const _driver = `${driver?.first_name} ${driver?.last_name}`;
        return _driver;
    };

    const handleUpdateDeliveryPaymentStatus = async (delivery_id: string, payment_status: 'paid' | 'unpaid') => {
        dispatch(updateDeliveryPaymentStatus({
            delivery_id,
            payment_status
        }));
    };

    const handleUpdateDeliveryPaymentMethod = async (delivery_id: string, payment_method: 'cash' | 'card' | 'eft') => {
        dispatch(updateDeliveryPaymentMethod({
            delivery_id,
            payment_method
        }));
    };

    const handleDeleteCustomer = (id: string) => {
        dispatch(deleteDelivery(id));
        setDeleteDialog(!isOpen);
    };

    useEffect(() => {}, [is_adding_delivery, is_updating_delivery]);

    return (
        <SimpleGrid columns={[1, null, 1]} spacing='40px'>
            <Box w='100%'>
                <TableContainer>
                    <Table variant='simple'>
                        <Thead>
                            <Tr>
                                <Th>Delivery ID</Th>
                                <Th>Full name</Th>
                                <Th>date and time</Th>
                                <Th>fleet</Th>
                                <Th>driver</Th>
                                <Th>vehicle</Th>
                                <Th>Pick-up</Th>
                                <Th>drop-off</Th>
                                <Th>status</Th>
                                <Th>payment status</Th>
                                <Th>payment method</Th>
                                <Th textAlign={'right'}>actions</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                currentTableData?.map((delivery: deliveryType, index: number) => (
                                    <Tr key={index}>
                                        <Td>{delivery?.delivery_id}</Td>
                                        <Td textTransform={'capitalize'}>{getCustomerFullname(delivery)}</Td>
                                        <Td>{moment(delivery?.date).format('YYYY-MM-DD')} | {delivery?.time} <DateTimeUpdater delivery={delivery} /></Td>
                                        <Td textTransform={'capitalize'}>{delivery?.fleet}</Td>
                                        <Td textTransform={'capitalize'}>
                                            {
                                                <HStack>
                                                    <Menu>
                                                        <MenuButton
                                                            as={IconButton}
                                                            aria-label='Options'
                                                            icon={
                                                                <Avatar
                                                                    size='xs'
                                                                    name={delivery?.driver_name}
                                                                />}
                                                            // bg={'transparent'}
                                                            borderRadius={'50%'}
                                                            style={{ height: '0px' }}
                                                        />
                                                        <MenuList>
                                                            <MenuItem key={index} onClick={() => dispatch(assignDeliveryDriver(`${delivery?._id}`, { driver_id: '', driver_name: '' }))}>
                                                                <HStack>
                                                                    <Stack p={1.5} bg={'#eeeeee'} borderRadius={'50%'}>
                                                                        <FiUser style={{ width: 14, height: 14 }} />
                                                                    </Stack>
                                                                    <Text textTransform={'capitalize'}>Unassign</Text>
                                                                </HStack>
                                                            </MenuItem>
                                                            {
                                                                drivers?.map((driver: vehicleDriverType, index: number) => (
                                                                    <MenuItem key={index} onClick={() => dispatch(assignDeliveryDriver(`${delivery?._id}`, { driver_id: driver?.user_id, driver_name: `${driver?.first_name} ${driver?.last_name}` }))}>
                                                                        <HStack>
                                                                            <Avatar
                                                                                size='xs'
                                                                                name={`${driver?.first_name} ${driver?.last_name}`}
                                                                            />
                                                                            <Text textTransform={'capitalize'}>{driver?.first_name} {driver?.last_name}</Text>
                                                                        </HStack>
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                        </MenuList>
                                                    </Menu>
                                                    <Text textTransform={'capitalize'} style={{ marginLeft: '0rem' }} fontStyle={getDriverName(delivery).includes('undefined') ? 'italic' : 'inherit'} color={getDriverName(delivery).includes('undefined') ? 'gray.400' : 'inherit'}>{getDriverName(delivery).includes('undefined') ? 'unassigned' : getDriverName(delivery)}</Text>
                                                </HStack>
                                                ||
                                                <Menu>
                                                    <MenuButton
                                                        as={IconButton}
                                                        aria-label='Options'
                                                        icon={<FiUser style={{ width: 20, height: 20 }} />}
                                                        // bg={'transparent'}
                                                        borderRadius={'50%'}
                                                        p={2}
                                                    />
                                                    <MenuList>
                                                        <MenuItem key={index} onClick={() => dispatch(assignDeliveryDriver(`${delivery?._id}`, { driver_id: '', driver_name: '' }))}>
                                                            <HStack>
                                                                <Stack p={1.5} bg={'#eeeeee'} borderRadius={'50%'}>
                                                                    <FiUser style={{ width: 14, height: 14 }} />
                                                                </Stack>
                                                                <Text textTransform={'capitalize'}>Unassigned</Text>
                                                            </HStack>
                                                        </MenuItem>
                                                        {
                                                            drivers?.map((driver: vehicleDriverType, index: number) => (
                                                                <MenuItem key={index} onClick={() => dispatch(assignDeliveryDriver(`${delivery?._id}`, { driver_id: driver?.user_id, driver_name: `${driver?.first_name} ${driver?.last_name}` }))}>
                                                                    <HStack>
                                                                        <Avatar
                                                                            size='xs'
                                                                            name={`${driver?.first_name} ${driver?.last_name}`}
                                                                        />
                                                                        <Text textTransform={'capitalize'}>{driver?.first_name} {driver?.last_name}</Text>
                                                                    </HStack>
                                                                </MenuItem>
                                                            ))
                                                        }
                                                    </MenuList>
                                                </Menu>
                                            }
                                        </Td>
                                        <Td textTransform={'capitalize'}>
                                            {
                                                <HStack>
                                                    <Menu>
                                                        <MenuButton
                                                            as={IconButton}
                                                            aria-label='Options'
                                                            icon={<BsTruck />}
                                                            // bg={'transparent'}
                                                            borderRadius={'50%'}
                                                            style={{ height: '0px' }}
                                                        />
                                                        <MenuList>
                                                            <MenuItem key={index} onClick={() => dispatch(assignDeliveryTruck(`${delivery?._id}`, { truck_id: '', truck_make: '' }))}>
                                                                <HStack>
                                                                    <Text textTransform={'capitalize'}>Unassign</Text>
                                                                </HStack>
                                                            </MenuItem>
                                                            {
                                                                vehicles?.map((vehicle: vehicelType, index: number) => (
                                                                    <MenuItem key={index} onClick={() => dispatch(assignDeliveryTruck(`${delivery?._id}`, { truck_id: vehicle?.vehicle_id, truck_make: `${vehicle?.make} - ${vehicle?.model}` }))}>
                                                                        <HStack>
                                                                            <Text textTransform={'capitalize'}>{vehicle?.make} - {vehicle?.model}</Text>
                                                                        </HStack>
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                        </MenuList>
                                                    </Menu>
                                                    <Text textTransform={'capitalize'} style={{ marginLeft: '0rem' }} fontStyle={getDriverName(delivery).includes('undefined') ? 'italic' : 'inherit'} color={getDriverName(delivery).includes('undefined') ? 'gray.400' : 'inherit'}>{getVehicleMake(delivery).includes('undefined') ? 'Unassigned' : getVehicleMake(delivery)}</Text>
                                                </HStack>
                                                ||
                                                <Menu>
                                                    <MenuButton
                                                        as={IconButton}
                                                        aria-label='Options'
                                                        icon={<BsTruck style={{ width: 20, height: 20 }} />}
                                                        // bg={'transparent'}
                                                        borderRadius={'50%'}
                                                        p={2}
                                                    />
                                                    <MenuList>
                                                        <MenuItem key={index} onClick={() => dispatch(assignDeliveryDriver(`${delivery?._id}`, { driver_id: '', driver_name: '' }))}>
                                                            <HStack>
                                                                <Text textTransform={'capitalize'}>Unassigned</Text>
                                                            </HStack>
                                                        </MenuItem>
                                                        {
                                                            vehicles?.map((vehicle: vehicelType, index: number) => (
                                                                <MenuItem key={index} onClick={() => dispatch(assignDeliveryTruck(`${delivery?._id}`, { truck_id: vehicle?.vehicle_id, truck_make: `${vehicle?.make} - ${vehicle?.model}` }))}>
                                                                    <HStack>
                                                                        <Text textTransform={'capitalize'}>{vehicle?.make} - {vehicle?.model}</Text>
                                                                    </HStack>
                                                                </MenuItem>
                                                            ))
                                                        }
                                                    </MenuList>
                                                </Menu>
                                            }
                                        </Td>
                                        <Td textTransform={'capitalize'}>
                                            <HStack>
                                                <Tooltip label={delivery?.from?.address_from}>{getAddressPlace(`${delivery?.from?.address_from}`)}</Tooltip>
                                                <AddressPickUpModalUpdater title='Pick-up address' delivery={delivery} />
                                            </HStack>
                                        </Td>
                                        <Td textTransform={'capitalize'}>
                                            <HStack>
                                                <Tooltip label={delivery?.to?.address_to}>{getAddressPlace(`${delivery?.to?.address_to}`)}</Tooltip>
                                                <AddressDropOffModalUpdater title='Drop-off address' delivery={delivery} />
                                            </HStack>
                                        </Td>
                                        <Td textTransform={'capitalize'}>
                                            <Menu>
                                                <MenuButton
                                                    // disabled={!delivery?.driver_id}
                                                    as={IconButton}
                                                    aria-label='Options'
                                                    icon={
                                                        <HStack bg={delivery?.status === 'approved' || delivery?.status === 'delivered' ? '#c6f4d2' : delivery?.status === 'upcoming' ? '#fefcbf' : '#edf2f7'}>
                                                            <Badge py={1} colorScheme={delivery?.status === 'approved' || delivery?.status === 'delivered' ? 'green' : delivery?.status === 'upcoming' ? 'yellow' : 'gray'} px={2} borderRadius={3}>{delivery?.status}</Badge>
                                                            <FiChevronDown style={{ paddingRight: 3 }} />
                                                        </HStack>
                                                    }
                                                    variant='outline'
                                                    style={{ height: '0px' }}
                                                />
                                                <MenuList>
                                                    {
                                                        statuses?.map((status: string, index: number) => (
                                                            <MenuItem key={index} textTransform={'capitalize'} onClick={() => dispatch(updateDeliveryStatus(`${delivery?._id}`, { status }))}>
                                                                {status}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </MenuList>
                                            </Menu>
                                        </Td>
                                        <Td textTransform={'capitalize'}>
                                            <Menu>
                                                <MenuButton
                                                    as={IconButton}
                                                    aria-label='Options'
                                                    icon={
                                                        <HStack bg={delivery?.payment_status === 'paid' ? '#c6f4d2' : '#edf2f7'}>
                                                            <Badge py={1} colorScheme={delivery?.payment_status === 'paid' ? 'green' : 'gray'} px={2} borderRadius={3}>{delivery?.payment_status}</Badge>
                                                            <FiChevronDown style={{ paddingRight: 3 }} />
                                                        </HStack>
                                                    }
                                                    variant='outline'
                                                    style={{ height: '0px' }}
                                                />
                                                <MenuList>
                                                    <MenuItem textTransform={'capitalize'} onClick={() => handleUpdateDeliveryPaymentStatus(`${delivery?.delivery_id}`, 'paid')}>
                                                        paid
                                                    </MenuItem>
                                                    <MenuItem textTransform={'capitalize'} onClick={() => handleUpdateDeliveryPaymentStatus(`${delivery?.delivery_id}`, 'unpaid')}>
                                                        unpaid
                                                    </MenuItem>
                                                </MenuList>
                                            </Menu>
                                        </Td>
                                        <Td textTransform={'capitalize'}>
                                            <Menu>
                                                <MenuButton
                                                    as={IconButton}
                                                    aria-label='Options'
                                                    icon={
                                                        <HStack bg={delivery?.payment_method === 'cash' ? '#c6f4d2' : '#edf2f7'}>
                                                            <Badge py={1} colorScheme={delivery?.payment_method === 'cash' ? 'green' : 'gray'} px={2} borderRadius={3}>{delivery?.payment_method}</Badge>
                                                            <FiChevronDown style={{ paddingRight: 3 }} />
                                                        </HStack>
                                                    }
                                                    variant='outline'
                                                    style={{ height: '0px' }}
                                                />
                                                <MenuList>
                                                    <MenuItem textTransform={'capitalize'} onClick={() => handleUpdateDeliveryPaymentMethod(`${delivery?.delivery_id}`, 'cash')}>
                                                        cash
                                                    </MenuItem>
                                                    <MenuItem textTransform={'capitalize'} onClick={() => handleUpdateDeliveryPaymentMethod(`${delivery?.delivery_id}`, 'card')}>
                                                        card
                                                    </MenuItem>
                                                    <MenuItem textTransform={'capitalize'} onClick={() => handleUpdateDeliveryPaymentMethod(`${delivery?.delivery_id}`, 'eft')}>
                                                        eft
                                                    </MenuItem>
                                                </MenuList>
                                            </Menu>
                                        </Td>
                                        <Td>
                                            <HStack>
                                                <Button colorScheme={'blue'} size='xs' onClick={() => navigate(`/deliveries/${delivery?.delivery_id}/edit`)}>
                                                    Edit
                                                </Button>
                                                <Button colorScheme={'red'} size='xs' onClick={() => setDeleteDialog(!isOpen)}>
                                                    {/* {on_vehicle_delete ? '...' : 'Delete'} */} Delete
                                                </Button>
                                            </HStack>
                                            <DeleteDialog
                                                id={`${delivery?._id}`}
                                                item='Delivery'
                                                isOpen={isOpen}
                                                onDelete={() => handleDeleteCustomer(`${delivery?._id}`)}
                                                onClose={() => setDeleteDialog(!isOpen)}
                                            />
                                        </Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                    {!deliveries.length && <EmptyTable title='Oops!' description='Your company does not have deliveries.' />}
                </TableContainer>
                <HStack mt={3} justifyContent={'flex-end'}>
                    <Pagination
                        className="pagination-bar"
                        currentPage={currentPage}
                        totalCount={deliveries.length}
                        pageSize={PageSize}
                        onPageChange={(page: any) => setCurrentPage(page)}
                    />
                </HStack>
            </Box>
        </SimpleGrid>
    );
};